// extracted by css-extract-rspack-plugin
export default {"image":"image___CGF96Tn7","image__placeholder":"image__placeholder___nhGGdNlw","image__img":"image__img___b7MCvlIn"};